/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Bookbuild_Configuredeal3Inputs */

const en_coinvestments_bookbuild_configuredeal3 = /** @type {(inputs: Coinvestments_Bookbuild_Configuredeal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure deal`)
};

/**
* | output |
* | --- |
* | "Configure deal" |
*
* @param {Coinvestments_Bookbuild_Configuredeal3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_bookbuild_configuredeal3 = /** @type {((inputs?: Coinvestments_Bookbuild_Configuredeal3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Bookbuild_Configuredeal3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_bookbuild_configuredeal3(inputs)
});
export { coinvestments_bookbuild_configuredeal3 as "coInvestments_bookBuild_configureDeal" }